import { emptyFunction } from "../../../../utils/function-utils";
import {
  ProcManagementPlaceUpsertService,
  ContextProps as BaseProps,
} from "../../proc-management/place-upsert-base";

export type AdditionalProps = {
  setOrganizationId: (organizationId: string) => void;
};

export type ContextProps = BaseProps & AdditionalProps;

export class ProcManagementPlaceCreateService extends ProcManagementPlaceUpsertService<AdditionalProps> {
  constructor() {
    super({
      setOrganizationId: emptyFunction,
    });
    this.state.setOrganizationId = this.setOrganizationId.bind(this);
  }

  setOrganizationId(organizationId: string) {
    const { place } = this.state;
    this.setState((prev) => {
      return { ...prev, place: { ...place, organizationId } };
    });
  }
}
